import api from '@/api/axiosConfig.js';

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.severidad) params.set('severidad', filters.severidad);
  if (filters.tipo) params.set('tipo', filters.tipo);
  if (filters.sucursalId) params.set('sucursal_id', filters.sucursalId);
  if (filters.desde) params.set('desde', filters.desde);
  if (filters.hasta) params.set('hasta', filters.hasta);
  if (filters.limit) params.set('limit', filters.limit);
  const query = params.toString();
  return query ? `?${query}` : '';
};

export async function getAlertasPriorizadas(filters = {}) {
  const response = await api.get(`/api/reportes/alertas-priorizadas${buildQuery(filters)}`);
  return response.data?.data;
}
